import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { EntryButtonStyled as EntryButton } from './styles/CustomEntriesStyled';
import AppContext from '../../App/AppContext';
import PlanInformation from '../../Home/PlanRecurrente/PlanInformation';
import Panel from '../../UI/Panel';
import { reload } from '../../../helpers';
import useSegment from '../../../hooks/useSegment';

const PlanZero = ({
  baseComponent: EntryComponent,
  children,
  autoOpen,
  ...props
}) => {
  const { hasPlanZero } = useContext(AppContext);
  const { isPrepaid } = useSegment();
  const [bundleBuySuccess, setBundleBuySuccess] = useState(false);

  const closeHandler = closeAction => {
    if (typeof closeAction !== 'undefined') {
      closeAction();
    }
    if (bundleBuySuccess) {
      reload();
    }
  };

  useEffect(() => {
    if ((hasPlanZero === false || !isPrepaid) && autoOpen) {
      navigate('/403');
    }
  }, []);

  if (!hasPlanZero) return null;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <EntryComponent {...props} onClick={() => {}}>
      <Panel
        activator={({ setShow }) => (
          <EntryButton onClick={() => setShow(true)}>{children}</EntryButton>
        )}
        bodyColor="white"
        closeCallback={closeHandler}
        isMobileDevice={false}
        showClose
        title="PLAN ZERO"
        showByDefault={autoOpen}
      >
        {({ setShow }) => (
          <PlanInformation
            segment="PREPAID"
            setBundleBuySuccess={setBundleBuySuccess}
            closePanel={() => closeHandler(() => setShow(false))}
          />
        )}
      </Panel>
    </EntryComponent>
  );
};

PlanZero.propTypes = {
  baseComponent: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
  autoOpen: PropTypes.bool,
};

PlanZero.defaultProps = {
  autoOpen: false,
};

export default PlanZero;
